<script setup lang="ts">
/**
 * Bridge component: Vue 2 v-model (value/input) → Vue 3 XInput (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordTextWuk/SwordPasswordWuk directly to XInput in global-components.ts
 */
import { XInput } from '@swordhealth/ui'

defineProps<{
  value?: string | number
  type?: string
}>()

const emit = defineEmits<{
  (e: 'input', value: string | number | boolean | object): void
}>()

function handleUpdate(newValue: string | number | boolean | object) {
  emit('input', newValue)
}
</script>

<template>
  <x-input
    v-bind="$attrs"
    :type="type"
    :model-value="value"
    @update:model-value="handleUpdate"
  />
</template>
